<div class="h-full flex flex-col items-center space-y-4 text-center bg-light-gray">
  <div class="flex flex-col justify-center items-center w-full mt-10">
    <img src="svg/campana.svg" class="logo-bienvenido" alt="Logo Bienvenido" />
    <h1 class="my-4 text-dark-blue font-bold text-2xl">Paga tu ahorro</h1>
  </div>
  <div class="row">
    <div class="flex flex-col text-xs font-thin text-black text-start">
      <div class="flex px-3 pt-2">
        1.
        <div class="pr-l">Ve a la oficina Fincomercio más cercana. <br /></div>
      </div>
      <div class="flex px-3 pt-2">
        2.
        <div class="pr-l">
          Con tu número de cédula podrás realizar el pago a uno de nuestros
          asesores en caja
        </div>
      </div>
    </div>
  </div>
  <div class="w-full">
    <div class="offset-md-6 col-md-5 text-end">
      <div class="row mt-2 p-2 bg-light-blue-100 rounded-md">
        <div
          class="bg-blue-100 h-auto w-full flex items-center text-xs"
          style="border-radius: 6px"
        >
          <p class="m-0 w-full text-start text-xs py-3 px-4">
            <b>Recuerda:</b> <br />
            Tienes hasta <b>{{ stringDate }}</b> para pagar la primera cuota.
          </p>
        </div>
      </div>
      <div class="row">
        <button type="button" (click)="next()" class="btn-primary mt-2">
          Consultar oficinas Fincomercio
        </button>
        <button type="button" (click)="finish()" class="btn-secundary mt-2">
          Finalizar
        </button>
      </div>
    </div>
  </div>
</div>
